import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Application',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Application',
    column_type: 'string',
  },
  desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_title: {
    model_name: 'Application',
    column_type: 'string',
  },
  wechat_application: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
    },
  },
  wechat_application_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
    },
  },
  non_flexible_desc: {
    model_name: 'Application',
    column_type: 'text',
  },
  semi_flexible_desc: {
    model_name: 'Application',
    column_type: 'text',
  },
  fully_flexible_desc: {
    model_name: 'Application',
    column_type: 'text',
  },
  nov_non_flexible_desc: {
    model_name: 'Application',
    column_type: 'text',
  },
  nov_semi_flexible_desc: {
    model_name: 'Application',
    column_type: 'text',
  },
  nov_fully_flexible_desc: {
    model_name: 'Application',
    column_type: 'text',
  },
  special_flexible_desc: {
    model_name: 'Application',
    column_type: 'text',
  },
  station_prompt: {
    model_name: 'Application',
    column_type: 'string',
  },
  std_ticket_tips: {
    model_name: 'Application',
    column_type: 'string',
  },
  sp_ticket_tips: {
    model_name: 'Application',
    column_type: 'string',
  },
  bp_ticket_tips: {
    model_name: 'Application',
    column_type: 'string',
  },
  homepage_local_scenery_ids: {
    model_name: 'Application',
    column_type: 'integer',
  },
  after_sales_reason_codes: {
    model_name: 'Application',
    column_type: 'string',
  },
  new_after_sale_code_notify_emails: {
    model_name: 'Application',
    column_type: 'string',
  },
  all_after_sale_codes: {
    model_name: 'Application',
    column_type: 'string',
  },
  home_popup_start_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  home_popup_end_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  standard_codes: {
    model_name: 'Application',
    column_type: 'string',
  },
  vip_codes: {
    model_name: 'Application',
    column_type: 'string',
  },
  business_codes: {
    model_name: 'Application',
    column_type: 'string',
  },
  application_admin_users_role_id: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  logo: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  banner_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  mine_banner_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  standard_services: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  standard_premier_services: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  business_premier_services: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  nov_standard_services: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  nov_standard_premier_services: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  nov_business_premier_services: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  homepage_local_sceneries: {
    model_name: 'Application',
    column_type: 'string',
  },
  home_popup_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  creator: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
    },
  },
  creator_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
    },
  },
  poster_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
